import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useCallback } from "react";
import { matchPath } from "react-router-dom";
import { usePathMatch } from "../hooks/usePathname";
export var PathnameSwitch = function (_ref) {
  var children = _ref.children,
    deriveMatch = useCallback(function (pathname) {
      return getRouteMatch(children, pathname);
    }, [children]);
  return usePathMatch(deriveMatch);
};
var getRouteMatch = function (children, pathname) {
  var element = null,
    match = null;
  return React.Children.forEach(children, function (child) {
    if (null == match && React.isValidElement(child)) {
      element = child;
      var path = child.props.path || child.props.from;
      match = path ? matchPath(pathname, _objectSpread(_objectSpread({}, child.props), {}, {
        path: path
      })) : {
        path: "/",
        url: "/",
        isExact: !1,
        params: {}
      };
    }
  }), match ? element : null;
};